import { features } from '@/mocks/data';

export default function FeatureSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
              为什么选择 KY App
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
              六大核心优势，为你带来卓越的移动应用体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {features.map((feature, idx) => (
              <div
                key={idx}
                className="group p-6 md:p-8 rounded-2xl bg-background-100 hover:bg-background-200/70 transition-colors duration-300 cursor-default"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-5 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${feature.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}